import React, { FC } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { SearchZeroResultsHelp } from './SearchZeroResultsHelp';
import {
  ZeroResultsContainer,
  ZeroResultsMain,
  ZeroResultsTitle,
} from './ZeroDecisionLib';
import { SearchTypes } from '../../search.types';
import styles from './search_zero_results.module.scss';
import {
  ZeroDecisionResultsButtonDecisionRef,
  ZeroDecisionResultsButtonOther,
} from './ZeroDecisionResultsButtons';

type Props = {
  hasDecisionRef: boolean;
  searchType: SearchTypes;
  enableWatchers: boolean;
};

export const ZeroDecisionResults: FC<Props> = ({
  enableWatchers,
  hasDecisionRef,
  searchType,
}) => {
  return (
    <ZeroResultsContainer data-test-id="zero-decision">
      <span
        className={classNames(
          styles.picto,
          hasDecisionRef ? styles.pictoDecision : styles.pictoWatcher,
        )}
      />
      <ZeroResultsMain>
        <ZeroResultsTitle>
          <FormattedMessage
            id={
              hasDecisionRef
                ? 'search/zero-results/ZeroDecisionResults.tsx/1'
                : 'search/zero-results/ZeroDecisionResults.tsx/2'
            }
          />
        </ZeroResultsTitle>
        {enableWatchers && (
          <>
            <p className={styles.message}>
              <FormattedMessage
                id={
                  hasDecisionRef
                    ? 'search/zero-results/ZeroDecisionResults.tsx/3'
                    : 'search/zero-results/ZeroDecisionResults.tsx/4'
                }
              />
            </p>
            <div className={styles.actions}>
              {hasDecisionRef ? (
                <ZeroDecisionResultsButtonDecisionRef />
              ) : (
                <ZeroDecisionResultsButtonOther />
              )}
            </div>
          </>
        )}
        <SearchZeroResultsHelp searchType={searchType} />
      </ZeroResultsMain>
    </ZeroResultsContainer>
  );
};
